// extracted by mini-css-extract-plugin
export default {"summary":"BookingDetails_summary__cOhPn"};